import { AnimatePresence, motion } from 'motion/react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useGetParams } from '../../hooks/useGetParams';

import { WinnerTitle } from './WinnerTitle';
import { Message } from '../Message/Message';
import { Confetti } from '../Confetti/Confetti';

import styles from './MessagesList.module.css';

export const MessagesList = ({
  messages,
  currentState,
  winId,
  speed,
  messagesRef,
}) => {
  const { authorFontSize } = useGetParams();

  const isWinner = currentState === 'S3';

  return (
    <motion.div
      className={styles.wrapper}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5, delay: 1 } }}
      exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
    >
      <AnimatePresence mode={'wait'}>
        {isWinner && (
          <div className={styles.winnerTitleBlock}>
            <motion.div
              initial={{ scaleX: 0, originX: '0%' }}
              animate={{
                scaleX: 1,
                originX: '0%',
                transition: { duration: 0.7, delay: 0.2 + 0.5 },
              }}
              exit={{ opacity: 0, transition: { duration: 0.5, delay: 0 } }}
              className={styles.winnerTitleBg}
            />
            <WinnerTitle className={styles.firstLine} startDelay={0.5} />
          </div>
        )}
      </AnimatePresence>
      {/* {isWinner && messagesRef?.length === 1 ? (
        <div style={{ marginTop: '7rem' }}>
          <Message
            message={messagesRef[0].message}
            winId={messagesRef[0].message?.id}
            authorFontSize={authorFontSize}
            isWinner={isWinner}
          />
        </div>
      ) :  */}

      <div className={styles.messagesWrapper}>
        <TransitionGroup className={styles.messages}>
          {messages.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={speed}
                classNames="position"
              >
                <Message
                  winId={winId}
                  // key={item.id}
                  message={item.message}
                  authorFontSize={authorFontSize}
                  isWinner={isWinner}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      </div>
      {isWinner && <Confetti />}
    </motion.div>
  );
};
